import React, { useEffect } from 'react'
import styles from './style.module.scss'
import Navbar from '../../Components/Navbar'
import { Helmet } from 'react-helmet'

import testimonial1 from '../../Assets/testimonials/1.jpg'
import testimonial2 from '../../Assets/testimonials/2.jpg'
import testimonial3 from '../../Assets/testimonials/3.jpg'
import testimonial4 from '../../Assets/testimonials/4.jpg'
import testimonial5 from '../../Assets/testimonials/5.jpg'
import testimonial6 from '../../Assets/testimonials/6.jpg'
import testimonial7 from '../../Assets/testimonials/7.jpg'
import testimonial8 from '../../Assets/testimonials/8.jpg'

import certificate1 from '../../Assets/testimonials/1b.jpg'
import certificate2 from '../../Assets/testimonials/2b.jpg'
import certificate3 from '../../Assets/testimonials/3b.jpg'
import certificate4 from '../../Assets/testimonials/4b.jpg'
import certificate5 from '../../Assets/testimonials/5b.jpg'
import certificate6 from '../../Assets/testimonials/6b.jpg'
import certificate7 from '../../Assets/testimonials/7b.jpg'
import certificate8 from '../../Assets/testimonials/8b.jpg'
import Copyrights from '../../Components/Copyrights'
import Aos from 'aos'
import 'aos/dist/aos.css';

const TestimonialsPage = () => {

  useEffect(() => {
    Aos.init({
      duration: 1000,
    })
  }, [])

  return (
    <div className={styles.container}>
      <Helmet>
        <title>Testimonials</title>
      </Helmet>
      <Navbar active="testimonials" />
      <div className={styles.testimonialsCont}>
        <a href={certificate1} target="_blank" rel="noopener noreferrer" data-aos="fade-up">
          <img src={testimonial1} alt="testimonials" />
        </a>
        <a href={certificate2} target="_blank" rel="noopener noreferrer" data-aos="fade-up">
          <img src={testimonial2} alt="testimonials" />
        </a>
        <a href={certificate3} target="_blank" rel="noopener noreferrer" data-aos="fade-up">
          <img src={testimonial3} alt="testimonials" />
        </a>
        <a href={certificate4} target="_blank" rel="noopener noreferrer" data-aos="fade-up">
          <img src={testimonial4} alt="testimonials" />
        </a>
        <a href={certificate5} target="_blank" rel="noopener noreferrer" data-aos="fade-up">
          <img src={testimonial5} alt="testimonials" />
        </a>
        <a href={certificate6} target="_blank" rel="noopener noreferrer" data-aos="fade-up">
          <img src={testimonial6} alt="testimonials" />
        </a>
        <a href={certificate7} target="_blank" rel="noopener noreferrer" data-aos="fade-up">
          <img src={testimonial7} alt="testimonials" />
        </a>
        <a href={certificate8} target="_blank" rel="noopener noreferrer" data-aos="fade-up">
          <img src={testimonial8} alt="testimonials" />
        </a>
      </div>
      <Copyrights />
    </div>
  )
}

export default TestimonialsPage